import { createSlice } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from 'services/api';

// Admin-side management of a specific client's sub users. Every thunk takes the
// clientId (a subclient_types.id — the row on the admin Client Accounts list)
// as its first argument, since the admin is not the client being managed.
export const adminClientSubUserInitialState = {
  subUser: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
};

export const adminClientSubUserSlice = createSlice({
  name: 'adminClientSubUser',
  initialState: adminClientSubUserInitialState,
  reducers: {
    setAdminClientSubUsers: (state, { payload }) => {
      state.subUser = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
  },
});

export const addAdminClientSubUsers = (clientId, data, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.addAdminClientSubUsers(clientId, data);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const updateAdminClientSubUsers = (clientId, data, itemId, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.updateAdminClientSubUsers(clientId, data, itemId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const removeAdminClientSubUsers = (clientId, itemId, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.removeAdminClientSubUsers(clientId, itemId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const fetchAdminClientSubUsers = (clientId, page, params, disableLoader) => async (dispatch) => {
  if (!disableLoader) dispatch(setLoader(true));
  try {
    const result = await Api.fetchAdminClientSubUsers(clientId, page, params);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setAdminClientSubUsers(result.data.data));
    } else if (result?.status === 422) {
      dispatch(setError(result.data));
    }
  } catch (error) {
    console.log('error', error);
  }
  if (!disableLoader) dispatch(setLoader(false));
};

export const changeAdminClientSubUserStatus = (clientId, id, data) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.clientStatusChange(id, data, `client/${clientId}/sub-users`);
    if (json.status === 422) {
      dispatch(setError(json.data));
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const removeMultipleAdminClientSubUsers = (clientId, ids, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.removeMultipleAdminClientSubUsers(clientId, ids);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const { setAdminClientSubUsers, setError, setLoader } = adminClientSubUserSlice.actions;

export default adminClientSubUserSlice.reducer;
export const adminClientSubUserSelector = (state) => state.adminClientSubUser;
